import { Database } from 'src/store/state/databases';
import { ReduxState } from 'src/store/types';

export const databaseSelector =
  (databaseId: string | null) =>
  (state: ReduxState): Database | undefined =>
    (databaseId && state.databases.databasesById[databaseId]) || undefined;
